import React, { useState } from 'react';
import { FaFileAlt, FaMoneyBillWave } from 'react-icons/fa';
import { FaCashRegister } from 'react-icons/fa';
import Layout from '../components/Layout';
import ModalExtrato from '../components/ModalExtrato'; // Importe o novo componente

const SaldoLanchonete = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [extratoAtual, setExtratoAtual] = useState([]);
  const isMobile = window.innerWidth < 768;

   const extratoDisponivel = [
    { 
      dataHora: '15/07/2023 10:30', 
      produto: 'Café + Pão de Queijo', 
      associado: 'João da Silva (Filho)', 
      valor: 'R$ 12,50' 
    },
    { 
      dataHora: '14/07/2023 12:15', 
      produto: 'Sanduíche Natural', 
      associado: 'Maria Oliveira (Filha)', 
      valor: 'R$ 18,90' 
    },
    { 
      dataHora: '13/07/2023 08:45', 
      produto: 'Suco de Laranja', 
      associado: 'Carlos Souza (Filho)', 
      valor: 'R$ 8,00' 
    },
  ];

  const extratoAnalise = [
    { 
      dataHora: '12/07/2023 09:20', 
      produto: 'Recarga de Saldo', 
      associado: 'Titular', 
      valor: 'R$ 100,00' 
    },
    { 
      dataHora: '10/07/2023 14:00', 
      produto: 'Recarga de Saldo', 
      associado: 'Titular', 
      valor: 'R$ 50,00' 
    },
  ];

  const abrirModalExtrato = (tipoExtrato) => {
    setExtratoAtual(tipoExtrato === 'disponivel' ? extratoDisponivel : extratoAnalise);
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
  };

  // Estilos que dependem de isMobile agora são funções
  const getStyles = () => ({
    container: {
      margin: '0 auto',
      fontFamily: '"Montserrat", sans-serif',
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
    },
    
    mobileContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '10px',
      width: '100%',
      gap: '20px'
    },
    
    desktopContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
      width: '100%',
      maxWidth: '800px',
      margin: '0 auto',
      gap: '20px'
    },

    cardContainer: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '20px',
      padding: '20px',
    },
    
    card: {
      backgroundColor: '#fff',
      borderRadius: '12px',
      padding: '25px',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
      display: 'flex',
      flexDirection: 'column',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      border: '1px solid #e9ecef',
      ':hover': {
        transform: 'translateY(-5px)',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)'
      }
    },
    
    cardHeader: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '15px',
    },
    
    cardIcon: {
      color: '#09448C',
      fontSize: '24px',
      marginRight: '12px',
    },
    
    cardTitle: {
      fontSize: '16px',
      fontWeight: '600',
      margin: '0',
      color: '#495057',
    },
    
    cardValue: {
      fontSize: '28px',
      fontWeight: '700',
      margin: '15px 0',
      color: '#212529',
    },
    
    cardFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 'auto',
    },
    
    cardInfo: {
      fontSize: '12px',
      color: '#6c757d',
      fontStyle: 'italic',
    },
    
    cardButton: {
      backgroundColor: 'transparent',
      color: '#09448C',
      border: '1px solid #09448C',
      borderRadius: '6px',
      padding: '8px 16px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s',
      ':hover': {
        backgroundColor: '#09448C',
        color: '#fff',
      }
    },
    
    sectionDivider: {
      height: '1px',
      backgroundColor: '#e9ecef',
      margin: '10px 20px',
    },
    
    resgateButton: {
      backgroundColor: '#09448C',
      color: '#fff',
      border: 'none',
      borderRadius: '8px',
      padding: '16px 24px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      width: isMobile ? '100%' : '50%',
      margin: '20px auto',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      transition: 'all 0.3s ease',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      ':hover': {
        backgroundColor: '#07316e',
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)'
      }
    },
    
    infoContainer: {
      backgroundColor: '#f1f8ff',
      borderRadius: '10px',
      padding: '20px',
      margin: '20px',
      borderLeft: '4px solid #09448C',
    },
    
    infoTitle: {
      color: '#09448C',
      marginTop: '0',
      marginBottom: '15px',
      fontSize: '16px',
    },
    
    infoList: {
      paddingLeft: '20px',
      margin: '0',
    },
    
    infoItem: {
      marginBottom: '8px',
      color: '#495057',
      fontSize: '14px',
      lineHeight: '1.5',
    }
  });

  const styles = getStyles();

   return (
    <div style={styles.container}>
      <Layout title="Saldo Lanchonete" icon={FaCashRegister}>
        {/* Cards principais */}
        <div style={styles.cardContainer}>
          {/* Card Saldo total em análise */}
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <FaFileAlt style={styles.cardIcon} />
              <h3 style={styles.cardTitle}>Saldo total em análise:</h3>
            </div>
            <p style={styles.cardValue}>R$ 2.000,00</p>
            <div style={styles.cardFooter}>
              <span style={styles.cardInfo}>Atualizado em: 15/07/2023</span>
              <button 
                style={styles.cardButton} 
                onClick={() => abrirModalExtrato('analise')}
              >
                VER EXTRATO
              </button>
            </div>
          </div>
          
          {/* Card Saldo disponível para resgate */}
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <FaMoneyBillWave style={styles.cardIcon} />
              <h3 style={styles.cardTitle}>Saldo disponível para resgate:</h3>
            </div>
            <p style={styles.cardValue}>R$ 1.500,00</p>
            <div style={styles.cardFooter}>
              <span style={styles.cardInfo}>Limite mínimo: R$ 50,00</span>
              <button 
                style={styles.cardButton} 
                onClick={() => abrirModalExtrato('disponivel')}
              >
                VER EXTRATO
              </button>
            </div>
          </div>
        </div>
        
        <div style={styles.sectionDivider}></div>
        
        {/* Informações adicionais */}
        <div style={styles.infoContainer}>
          <h4 style={styles.infoTitle}>Informações importantes:</h4>
          <ul style={styles.infoList}>
            <li style={styles.infoItem}>O saldo <u>em análise</u> corresponde às recargas que já foram feitas, mas ainda não converteram em pagamento na lanchonete</li>
            <li style={styles.infoItem}>O saldo <u>disponível para resgate</u> é o que já foi utilizado em pagamentos e, portanto, já podem ser resgatados via PIX</li>
          </ul>
        </div>
        
        {/* Modal de Extrato */}
        {modalAberto && (
          <ModalExtrato 
            extrato={extratoAtual} 
            onClose={fecharModal} 
          />
        )}
      </Layout>
    </div>
  );
};

export default SaldoLanchonete;